import React from "react";
import {
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
  Button,
  Text,
} from "@chakra-ui/react";
export const SubscriptionPlan = ({ subscriptionPlans, onEdit }) => {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      <Table>
        <Thead>
          <Tr>
            <Th>Price</Th>
            <Th>Currency</Th>
            <Th>Frquency</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {subscriptionPlans.map(
            ({
              id,
              price,
              currency,
              frequency,
            }) => (
              <Tr key={id}>
                <Td fontWeight="600" color="blue.500">{price}</Td>
                <Td>{currency}</Td>
                <Td>{frequency}</Td>
                <Td>
                  <Button
                    colorScheme="blue"
                    fontWeight="600"
                    variant="outline"
                    onClick={() => onEdit(id)}
                    width="50%"
                  >
                    Edit
                  </Button>
                </Td>
              </Tr>
            )
          )}
        </Tbody>
      </Table>
      {subscriptionPlans.length === 0 && (
        <Text width="100%" textAlign="center" fontSize="lg" padding="10px 0">
          No plans are there. Add new plans.
        </Text>
      )}
    </Box>
  );
};
